import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-ticket-image-dialog',
  templateUrl: './ticket-image-dialog.component.html',
  styleUrls: ['./ticket-image-dialog.component.scss']
})
export class TicketImageDialogComponent {
  picture:any;
  tickets: any[] | null = null;
  staffList: any[] = [];
  campusName = '';
  buildingName = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private dialogRef: MatDialogRef<TicketImageDialogComponent>
  ) {
    if (data && data.tickets) {
      this.tickets = Array.isArray(data.tickets) ? data.tickets : [data.tickets];
      this.picture = null;
      
      
    } else {
      this.picture = data.picture;
      const p = data.picture as any;
      this.campusName = p?.campusName ?? '';
      this.buildingName = p?.buildingName ?? '';
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  formatHygieneTime(dateStr: string): string {
    if (!dateStr) return '';
    const parts = dateStr.split(' ');
    if (parts.length >= 2 && parts[1] !== '00:00:00') {
      const [h, m, s] = parts[1].split(':');
      const hh = parseInt(h || '0', 10);
      const ampm = hh >= 12 ? 'PM' : 'AM';
      const h12 = hh % 12 || 12;
      return `${String(h12).padStart(2, '0')}:${m}:${s} ${ampm}`;
    }
    return parts[0] || dateStr;
  }
}
